import React from 'react'

function IconAddForm() {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 24 29"
      fill="none"
      id="addUser"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 25.375V22.9583C16 21.6765 15.5786 20.4471 14.8284 19.5407C14.0783 18.6342 13.0609 18.125 12 18.125H5C3.93913 18.125 2.92172 18.6342 2.17157 19.5407C1.42143 20.4471 1 21.6765 1 22.9583V25.375"
        stroke="#CAD3AF"
        strokeOpacity="0.941176"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 13.2917C10.7091 13.2917 12.5 11.1277 12.5 8.45833C12.5 5.78896 10.7091 3.625 8.5 3.625C6.29086 3.625 4.5 5.78896 4.5 8.45833C4.5 11.1277 6.29086 13.2917 8.5 13.2917Z"
        stroke="#CAD3AF"
        strokeOpacity="0.941176"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 9.66666V16.9167"
        stroke="#CAD3AF"
        strokeOpacity="0.941176"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 13.2917H17"
        stroke="#CAD3AF"
        strokeOpacity="0.941176"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default IconAddForm
